import { Button, ModalConfirm } from '@byecode/ui'
import React, { useCallback, useState } from 'react'
import { useBlocker } from 'react-router-dom'
import { useBeforeUnload } from 'react-use'

import { FlowDetailShape, useFlowContainerContext } from '@/contexts/FlowContext'

import { usePersistFlow } from '../../hook/usePersistFlow'

export const FlowLeave: React.FC = () => {
    const { shape, isChanged, onClose, closeConfirmOpen, setCloseConfirmOpen } = useFlowContainerContext()
    const { persistFlow } = usePersistFlow()
    const [isSaveAndLeaveLoading, setIsSaveAndLeaveLoading] = useState(false)
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            shape === FlowDetailShape.PAGE && isChanged && currentLocation.pathname !== nextLocation.pathname
    )

    const handleSaveAndLeave = useCallback(async () => {
        setIsSaveAndLeaveLoading(true)
        const isSuccess = await persistFlow()
        setIsSaveAndLeaveLoading(false)

        if (!isSuccess) {
            return
        }

        if (shape === FlowDetailShape.MODAL) {
            setCloseConfirmOpen(false)
            onClose?.()
            return
        }

        blocker?.proceed?.()
    }, [blocker, onClose, persistFlow, setCloseConfirmOpen, shape])

    const handleKeepEditing = useCallback(() => {
        if (shape === FlowDetailShape.MODAL) {
            setCloseConfirmOpen(false)
            return
        }

        blocker?.reset?.()
    }, [blocker, setCloseConfirmOpen, shape])

    const handleDiscard = useCallback(() => {
        if (shape === FlowDetailShape.MODAL) {
            setCloseConfirmOpen(false)
            onClose?.()
            return
        }

        blocker?.proceed?.()
    }, [blocker, onClose, setCloseConfirmOpen, shape])

    useBeforeUnload(shape === FlowDetailShape.PAGE && isChanged, '你修改了工作流设计但没有保存，是否需要保存工作流设计并继续？')

    if (shape === FlowDetailShape.MODAL && closeConfirmOpen && isChanged) {
        return (
            <ModalConfirm
                title="工作流设计有修改，是否保存？"
                content="你修改了工作流设计但没有保存，是否需要保存工作流设计并关闭？"
                closeOnEscape={false}
                footerExtra={
                    <Button type="text" size="sm" onClick={handleKeepEditing}>
                        返回设计
                    </Button>
                }
                onReject={handleDiscard}
                onResolve={handleSaveAndLeave}
                okStatus="primary"
                okText="保存并关闭"
                okProps={{ loading: isSaveAndLeaveLoading }}
                cancelText="不保存"
            />
        )
    }

    if (!blocker || blocker.state !== 'blocked') {
        return null
    }

    return (
        <ModalConfirm
            title="工作流设计有修改，是否保存？"
            content="你修改了工作流设计但没有保存，是否需要保存工作流设计并继续？"
            closeOnEscape={false}
            footerExtra={
                <Button type="text" size="sm" onClick={handleKeepEditing}>
                    返回设计
                </Button>
            }
            onReject={handleDiscard}
            onResolve={handleSaveAndLeave}
            okStatus="primary"
            okText="保存并继续"
            okProps={{ loading: isSaveAndLeaveLoading }}
            cancelText="不保存"
        />
    )
}
